import TimeSlot from "./TimeSlot";
import ApiService from "../ApiService";
import { groupBy } from "@/utilities";

let checkLinkHasProtocol = link =>
  link.indexOf("://") === -1 ? "//" + link : link;

class Notary {
  constructor(data = {}) {
    this.id = data.id;
    this.email = data.email || "-";
    this.phone = data.phone_number || "-";
    this.city = data.city || "";
    this.address = data.address || "";
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.middle_name = data.middle_name;
    this.site_url = data.site_url;
    this.full_name = data.full_name;
    this.timetable = [];
    this.is_client = false;
    this.avatar_url = this.getAvatarUrl(data.avatar_url, data.site_url);
    this.chat_enabled = data.chat_enabled;
    this.type = "notary";
    this.sources = data.sources || [];
  }

  getAvatarUrl(imgUrl, siteUrl) {
    return imgUrl && siteUrl ? checkLinkHasProtocol(siteUrl + imgUrl) : "";
  }

  getSiteUrl() {
    return checkLinkHasProtocol(this.site_url);
  }
  getFullName() {
    return `${this.last_name} ${this.first_name} ${this.middle_name}`;
  }
  getFullAddress() {
    return this.city && this.address ? `${this.city}, ${this.address}` : "-";
  }
  getSortedTimetable() {
    return this.timetable.sort((a, b) => a.start_datetime - b.start_datetime);
  }

  async setChatAvailability(value) {
    await ApiService.put(`/notary/${this.id}/`, { chat_enabled: value });
    this.chat_enabled = value;
  }

  /**
   * Returns grouped by date time-slots
   */
  getGroupedAvailableDates(date) {
    if (this.timetable.length > 0) {
      let grouped = groupBy(this.timetable, "date");
      return date ? grouped[date] : grouped;
    } else {
      return {};
    }
  }

  /**
   * Get notary's available <TimeSlot>
   * set it to timetable and return
   */
  async getAvailableDates() {
    let res = await ApiService.get(`/timeslot/?notary=${this.id}`);
    this.timetable = res.data.map(el => new TimeSlot(el));
    return this.timetable;
  }

  /**
   * Add <TimeSlot> to notary
   */
  async addDateTimeInterval(slot) {
    let res = await ApiService.post(`/timeslot/`, {
      notary: this.id,
      ...slot
    });
    this.timetable.push(new TimeSlot(res.data));
  }

  /**
   * Delete <TimeSlot>
   */
  async deleteTimeInterval(id, index) {
    await ApiService.delete(`/timeslot/${id}`);
    this.timetable.splice(index, 1);
  }

  async getFreeTimeForSlots(){
    let resp = await ApiService.get('/free-timeslot/');
    let slots = resp.data.reduce((acc, el) => {
      acc[el.id] = el.times.map(time => new Date(`${el.date}T${time}`));
      return acc;
    }, {})

    return slots;
  }
}

export default Notary;
